module.exports = __webpack_public_path__ + "media/images/logo/Logo(H)_Navy-a387d4130c8f348f244dd2676657c873.png";